var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#002979"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5003 5.75016C11.2117 5.75016 10.167 6.79483 10.167 8.0835V9.8335H14.8337V8.0835C14.8337 6.79483 13.789 5.75016 12.5003 5.75016ZM9.58366 11.0002L9.58441 11.0002H15.4162L15.417 11.0002L15.4177 11.0002H17.167V16.2502H7.83366V11.0002H9.5829L9.58366 11.0002ZM16.0003 8.0835V9.8335H17.167C17.8113 9.8335 18.3337 10.3558 18.3337 11.0002V16.2502C18.3337 16.8945 17.8113 17.4168 17.167 17.4168H7.83366C7.18933 17.4168 6.66699 16.8945 6.66699 16.2502V11.0002C6.66699 10.3558 7.18933 9.8335 7.83366 9.8335H9.00033V8.0835C9.00033 6.1505 10.5673 4.5835 12.5003 4.5835C14.4333 4.5835 16.0003 6.1505 16.0003 8.0835ZM13.0837 12.7502C13.0837 12.428 12.8225 12.1668 12.5003 12.1668C12.1782 12.1668 11.917 12.428 11.917 12.7502V14.5002C11.917 14.8223 12.1782 15.0835 12.5003 15.0835C12.8225 15.0835 13.0837 14.8223 13.0837 14.5002V12.7502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockableIcon);
export default __webpack_public_path__ + "static/media/unlockable-icon.69527c7c5e3638dae8e966f2d181e1f0.svg";
export { ForwardRef as ReactComponent };